import { VariaveisAmbiente } from 'config';
import { PropagandaModel } from 'model/api/gestao/propaganda/propaganda-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';

export function useGetPropagandas() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<PropagandaModel>>();

    const getPropagandas = useCallback(

        async (page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `/v1/Propagandas${queryFinal}`,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                method: 'GET',
                enviarTokenUsuario: true
            })
        },
        [invocarApi]);
    return {
        ...outrasPropriedades,
        getPropagandas,
    };
}
